export const OAuth2QueryParameters = {
  CLIENT_ID: "client_id",
  CLIENT_SECRET: "client_secret",
  RESPONSE_TYPE: "response_type",
  REDIRECT_URI: "redirect_uri",
  SCOPE: "scope",
  CODE: "code",
  STATE: "state",
  SESSION: "session",
  CODE_CHALLENGE: "code_challenge",
  CODE_CHALLENGE_METHOD: "code_challenge_method",
  THEME: "theme"
};
